module.exports = __webpack_public_path__ + "static/the-culture-code-4bbee3f9b97f1d6f693e7e5ec82b9ec7.jpg";